module.exports = __webpack_public_path__ + "85028badd3a42a875bfb46f168f662fd.png";